import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconPersonOff(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M22 12C22 13.5679 21.6386 15.0519 20.9945 16.3732L19.4696 14.8483C19.8108 13.9648 20 13.0053 20 12C20 7.59 16.41 4 12 4C10.9956 4 10.0338 4.18621 9.14722 4.5259L7.62682 3.0055C8.94809 2.36144 10.4321 2 12 2C17.52 2 22 6.48 22 12Z"
        fill="currentColor"
      />
      <path
        d="M15.5 9.5C15.5 9.91356 15.4291 10.3098 15.2988 10.6774L10.8226 6.20124C11.1902 6.07089 11.5864 6 12 6C13.94 6 15.5 7.56 15.5 9.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.826 6.24022C2.67586 7.86887 2 9.85599 2 12C2 17.52 6.48 22 12 22C14.144 22 16.1311 21.3241 17.7598 20.174L19.2929 21.7071C19.6834 22.0976 20.3166 22.0976 20.7071 21.7071C21.0976 21.3166 21.0976 20.6834 20.7071 20.2929L3.70711 3.29289C3.31658 2.90237 2.68342 2.90237 2.29289 3.29289C1.90237 3.68342 1.90237 4.31658 2.29289 4.70711L3.826 6.24022ZM9.85989 12.2741L12.0864 14.5007C12.0569 14.5002 12.0281 14.5 12 14.5C10.54 14.5 7.07 15.09 5.64 16.83C4.62 15.49 4 13.82 4 12C4 10.4112 4.46594 8.92891 5.26831 7.68252L9.22589 11.6401C9.40911 11.8777 9.62229 12.0909 9.85989 12.2741Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
